import styled from 'styled-components';

import { type TaskTemplate } from '@mai/types';

import TemplateField from './TemplateField';
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE } from './constants';

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ScrollableFields = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding-right: ${({ theme }) => `${theme.token.paddingSM}px`};
`;

type TemplateFieldsStepProps = {
  selectedTemplate?: TaskTemplate | null;
};

const TemplateFieldsStep = ({ selectedTemplate }: TemplateFieldsStepProps) => {
  return (
    <StepContainer>
      <ScrollableFields>
        {(
          selectedTemplate?.fields || [
            {
              name: 'title',
              title: 'Title',
              type: 'text',
              required: true,
              default: DEFAULT_TITLE,
              description: 'The title of the task',
              example: 'My Task',
            },
            {
              name: 'description',
              title: 'Description',
              type: 'textarea',
              required: true,
              default: DEFAULT_DESCRIPTION,
              description: 'The description of the task',
              example: 'This is a task description',
            },
          ]
        ).map((field) => (
          <TemplateField key={field.name} field={field} />
        ))}
      </ScrollableFields>
    </StepContainer>
  );
};

export default TemplateFieldsStep;
